import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=50665488&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=js&"
export * from "./SideNav.vue?vue&type=script&lang=js&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=50665488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50665488",
  null
  
)

export default component.exports